import moment from "moment";

export function today() {
    return moment();
}

export function getCurrentHourInHundredths() {
    return moment().hours() + moment().minutes() / 60;
}

export function getStartHourOfIntervention(stateAccessor) {
    let myOpenStartDate = moment(stateAccessor.intervention.myOpenStartDate, "DD/MM/YYYY HH:mm");
    return myOpenStartDate.hours() + myOpenStartDate.minutes() / 60;
}

export function getFluidDetectorMark(stateAccessor) {
    return stateAccessor.loggedEmployee ? stateAccessor.loggedEmployee.leak_detector_brand : "";
}

export function getFluidDetectorModel(stateAccessor) {
    return stateAccessor.loggedEmployee ? stateAccessor.loggedEmployee.leak_detector_model : "";
}

export function getFluidDetectorId(stateAccessor) {
    return stateAccessor.loggedEmployee ? stateAccessor.loggedEmployee.leak_detector_identification : 0;
}

export function getFluidDetectorDate(stateAccessor) {
    return stateAccessor.loggedEmployee && stateAccessor.loggedEmployee.leak_detector_last_check_date
        ? moment(stateAccessor.loggedEmployee.leak_detector_last_check_date, "DD/MM/YYYY")
        : null;
}

export function checkFluidTypesOk(stateAccessor, filledFluidBottles, selectedFluidTypeModelAndValue) {
    let typesOk = true;

    if (!Array.isArray(stateAccessor.fluidBottles)) {
        console.error(
            "Impossible d'exécuter la fonction évaluée [checkFluidTypesOk] car la liste des bouteilles de fluide du technicien est introuvable"
        );
        return typesOk;
    }

    let selectedFluidType = selectedFluidTypeModelAndValue.choice_ids.find(
        (c) => c.id === selectedFluidTypeModelAndValue.value_choice_id
    );

    if (!selectedFluidType) {
        console.error(
            "Impossible d'exécuter la fonction évaluée [checkFluidTypesOk] car le type de fluide sélectionné est introuvable dans la liste"
        );
        return typesOk;
    }

    filledFluidBottles.forEach((ffb) => {
        let fluidBottleName = ffb.value_text.trim();

        let fluidBottle = stateAccessor.fluidBottles.find((fb) => fb.name === fluidBottleName);
        if (!fluidBottle) return;

        if (selectedFluidType.code !== fluidBottle.product_code) typesOk = false;
    });

    return typesOk;
}

export function checkFluidQuantitiesOk(stateAccessor, filledFluidBottles) {
    let quantitiesOk = true;

    if (!Array.isArray(stateAccessor.fluidBottles)) {
        console.error(
            "Impossible d'exécuter la fonction évaluée [checkFluidQuantitiesOk] car la liste des bouteilles de fluide du technicien est introuvable"
        );
        return quantitiesOk;
    }

    for (let i = 0; i < filledFluidBottles.length; i++) {
        let fluidBottleName = filledFluidBottles[i].value_text.trim();

        let fluidBottle = stateAccessor.fluidBottles.find((fb) => fb.name === fluidBottleName);
        if (!fluidBottle) continue;

        if (parseFloat(filledFluidBottles[i].value_float) > fluidBottle.stock_net) quantitiesOk = false;
    }

    return quantitiesOk;
}

export function checkProdlotListCorrectlyFilled(prodlotListField) {
    let prodlotListOk = true;

    prodlotListField.value_field_ids
        .filter((prodlot) => !prodlot.deleted)
        .forEach((prodlot) => {
            if (!prodlot.value_text || !prodlot.value_float || prodlot.value_float <= 0) prodlotListOk = false;
        });

    return prodlotListOk;
}

export function getDefaultContactAttribute(stateAccessor, attributeNeeded) {
    if (!stateAccessor.intervention) return "";

    let contact = stateAccessor.intervention.delivery_contact_id;

    if (!contact) return "";

    return contact[attributeNeeded];
}

export function getLabelOfChoiceById(fieldTypeAndValue) {
    let choice = fieldTypeAndValue.choice_ids.find((c) => c.id === fieldTypeAndValue.value_choice_id);

    if (!choice) return "";

    return choice.name;
}

export function getCerfaSubTitle(designationEquipmentField, typeFluidField) {
    let designation;
    if (designationEquipmentField) {
        designation = designationEquipmentField.value_text;
    }
    let typeFluid;
    if (typeFluidField) {
        typeFluid = getLabelOfChoiceById(typeFluidField);
    }
    let cerfaTitle = "";

    if (designation) cerfaTitle = designation;

    if (designation && typeFluid) cerfaTitle = cerfaTitle.concat(" - ");

    if (typeFluid) cerfaTitle = cerfaTitle.concat(typeFluid);

    return cerfaTitle;
}

export function checkEmailValid(value) {
    //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !value || re.test(String(value).toLowerCase());
}

export function haveValidSPP(stateAccessor) {
    return stateAccessor.sppFound;
}
